import React from "react";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import { IProductColor, IViewImage } from "../interfaces/IProduct";
import { IView } from "../interfaces/IView";
import {
  createProductViewCanvas,
  setSelectedView,
} from "../store/slices/viewSlice";
import classNames from "classnames";

interface ViewThumbnailsProp {}

const ViewThumbnails: React.FC<ViewThumbnailsProp> = ({}) => {
  const dispatch = useAppDispatch();
  const viewData = useAppSelector(
    (state: any) => state.canvases.original_view_data
  );
  const selectedColor: IProductColor = useAppSelector(
    (state: any) => state.product.selected_color
  );
  const selectedViewId = useAppSelector(
    (state: any) => state.canvases.selectedViewId
  );
  const getViewImage: any = (viewId: string) => {
    let viewInfo: IViewImage | null = null;
    for (let index = 0; index < selectedColor.views.length; index++) {
      const view = selectedColor.views[index];
      if (view.id === viewId) {
        viewInfo = view;
      }
    }

    return viewInfo?.img;
  };
  return (
    <>
      <div className="m-1 mt-1 mb-1 flex justify-center hidden md:block">
        {viewData &&
          viewData.length &&
          viewData.map((view: IView, index: any) => {
            return selectedViewId == view.id ? (
              <span
                key={index}
                onClick={() => {
                  dispatch(setSelectedView(view.id));
                }}
                className="bg-[#DBF2FA] cursor-pointer text-[#1164A9] font-medium me-2 px-3 py-1.5 rounded-full mb-1"
              >
                {view.name}
              </span>
            ) : (
              <span
                key={index}
                onClick={() => {
                  dispatch(setSelectedView(view.id));
                }}
                className="bg-transparent cursor-pointer text-[#222222] font-medium me-2 px-3 py-1.5 mb-4 rounded-full"
              >
                {view.name}
              </span>
            );
          })}
      </div>
    </>
  );
};

export default ViewThumbnails;
